import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm-5-7h5.586l-1.293 1.293 1.414 1.414L16.414 12l-3.707-3.707-1.414 1.414L12.586 11H7v2z" }));
export default createSvgIcon(iconPath, "Ready");
//# sourceMappingURL=StatusReadyIcon.js.map